const prefix = "mobileScreen";

const CHANGE_MOBILE_SCREEN_WIDTH = `${prefix}:CHANGE_MOBILE_SCREEN_WIDTH`;

export const actionTypes = {
  CHANGE_MOBILE_SCREEN_WIDTH
};

const changeMobileScreenWidth = (width, isMobilePortrait) => {
  return {
    type: CHANGE_MOBILE_SCREEN_WIDTH,
    width,
    isMobilePortrait
  };
};

export default {
  changeMobileScreenWidth
};
